import { useEffect, useRef } from "react";
import { useMap } from "@vis.gl/react-google-maps";

import { getRadiusInMeters } from "./helpers";

import { LocationData, PolygonGeometry } from "./types";

type MapViewportManagerProps = {
  coords?: number[] | null;
  boundry?: PolygonGeometry | null;
  geoJSON?: PolygonGeometry | null;
  hasSearch?: boolean;
  isDrawing?: boolean;
  locationData?: LocationData | null;
  radius?: number | string;
  radiusType?: string | null;
  searchType?: string;
};

const MapViewportManager = ({
  coords = null,
  boundry = null,
  geoJSON = null,
  hasSearch = false,
  isDrawing = false,
  locationData = null,
  radius = 0,
  radiusType = null,
  searchType = "radius",
}: MapViewportManagerProps) => {
  const map = useMap();
  const circleRef = useRef<google.maps.Circle | null>(null);

  const clearCircle = () => {
    if (circleRef.current) {
      circleRef.current.setMap(null);
      circleRef.current = null;
    }
  };

  useEffect(() => {
    if (!map && !hasSearch && !boundry && !geoJSON) return;

    clearCircle();

    if (searchType === "radius" && !isDrawing && coords?.length === 2) {
      const rad = radiusType === "smart-radius" ? locationData?.radius : radius;

      if (rad) {
        circleRef.current = new window.google.maps.Circle({
          strokeColor: "#59c4c3",
          strokeWeight: 2,
          fillColor: "#59c4c3",
          fillOpacity: 0.4,
          map,
          center: { lat: coords[0], lng: coords[1] },
          radius: getRadiusInMeters(rad),
        });

        map.fitBounds(circleRef.current.getBounds());
      }
    }

    return () => {
      clearCircle();
    };
  }, [map, coords, boundry, geoJSON, hasSearch, isDrawing, locationData, radius, radiusType, searchType]);

  return null;
};

export default MapViewportManager;
